import { createAction } from 'redux-act'

import { UnreviewedProductsResponse } from './types'

const fetchUnreviwedProductsStart = createAction(
  'unreviwedProducts / fetch unreviewed products start',
)
const fetchUnreviwedProductsSuccess = createAction<UnreviewedProductsResponse>(
  'unreviwedProducts / fetch unreviewed products success',
)
const fetchUnreviwedProductsFail = createAction(
  'unreviwedProducts / fetch unreviewed products fail',
)

const createReviewStart = createAction('unreviwedProducts / creating product review start')
const createReviewSuccess = createAction<UnreviewedProductsResponse>(
  'unreviwedProducts / creating product review success',
)
const createReviewFail = createAction('unreviwedProducts / creating product review fail')

export default {
  fetchUnreviwedProductsStart,
  fetchUnreviwedProductsSuccess,
  fetchUnreviwedProductsFail,
  createReviewStart,
  createReviewSuccess,
  createReviewFail,
}
